<template>
  <ButtonIconNeutralSecondary
    size="large"
    @click="refreshData"
  >
    <svg
      ref="refreshIcon"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_9839_16717)">
        <path
          d="M16.7913 3.33312V7.58312M16.7913 7.58312H12.5413M16.7913 7.58312L13.5047
          4.49479C12.7434 3.73313 11.8016 3.17673 10.7671 2.8775C9.73263 2.57828 8.63921
           2.54599 7.58888 2.78364C6.53855 3.02129 5.56553 3.52114 4.76063 4.23654C3.95573
           4.95195 3.34517 5.8596 2.98592 6.87479M1.20801 14.6665V10.4165M1.20801
           10.4165H5.45801M1.20801 10.4165L4.49467 13.5048C5.25595 14.2665 6.19777
           14.8229 7.23225 15.1221C8.26672 15.4213 9.36014 15.4536 10.4105 15.2159C11.4608
           14.9783 12.4338 14.4784 13.2387 13.763C14.0436 13.0476 14.6542 12.14 15.0134 11.1248"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9839_16717">
          <rect
            width="17"
            height="17"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  </ButtonIconNeutralSecondary>
</template>

<script setup>
import { ref } from "vue";

const refreshIcon = ref(null);

const refreshData = () => {
  // Добавляем класс анимации
  if (refreshIcon.value) {
    refreshIcon.value.classList.add("rotating");
    
    // Убираем класс после завершения анимации
    setTimeout(() => {
      if (refreshIcon.value) {
        refreshIcon.value.classList.remove("rotating");
      }
    }, 1000);
  }
};
</script>

<style scoped lang="scss">
// Анимация вращения для SVG
svg.rotating {
  animation: rotate 1s linear;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>